import PropTypes from 'prop-types';
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { IconButton } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

// Сортируемый элемент панели с Drag-and-Drop
function SortablePanelItem({ id, children }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: 'flex',
    alignItems: 'start',
  };

  return (
    <div ref={setNodeRef} style={style}>
      <IconButton {...listeners} {...attributes} sx={{ cursor: 'grab', mt: '8px' }}>
        <DragIndicatorIcon sx={{ width: '32px', height: '32px', p: 0 }} />
      </IconButton>

      <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
    </div>
  );
}

SortablePanelItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.node.isRequired,
};

export default SortablePanelItem;